var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cart-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.222,
    height: 19.222,
    viewBox: "0 0 19.222 19.222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M.641,1.281H2.7l2.265,9.627a1.917,1.917,0,0,0,.165,3.828H16.018a.641.641,0,0,0,0-1.281H5.126a.641.641,0,0,1,0-1.281H15.942a1.916,1.916,0,0,0,1.871-1.482l1.358-5.766A1.922,1.922,0,0,0,17.3,2.563H4.314L3.828.494A.641.641,0,0,0,3.2,0H.641a.641.641,0,1,0,0,1.281ZM17.3,3.844a.651.651,0,0,1,.624.787L16.565,10.4a.637.637,0,0,1-.623.494H6.274L4.613,3.844Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M23.433,31.521A1.922,1.922,0,1,0,24,30.162a1.922,1.922,0,0,0-.563,1.359Zm2.563,0a.641.641,0,1,1-.188-.453A.641.641,0,0,1,26,31.521Z",
    transform: "translate(-11.259 -14.222)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M9.866,31.521a1.922,1.922,0,1,0,.563-1.359,1.922,1.922,0,0,0-.563,1.359Zm2.563,0a.641.641,0,1,1-.188-.453A.641.641,0,0,1,12.429,31.521Z",
    transform: "translate(-4.741 -14.222)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconWhite);
export default __webpack_public_path__ + "static/media/cart-icon-white.bf1d36c8f0454113095ca6195ba7b926.svg";
export { ForwardRef as ReactComponent };